import React from 'react'

import Content from 'components/shared/Content'
import * as beacon from 'utils/beacon'

interface IProps {
  sensor: any
}

const style = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

const Gasmatic = ({ sensor }: IProps) => {
  const level = beacon.calcLevel(sensor, sensor.settings)
  return <Content style={style} label="Level" value={`${(level * 100).toFixed(2)} %`} />
}

export default Gasmatic
